
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const DriverScoreButtons: React.FC<{ onScoreChange: (score: number) => void; testId?: string }> = ({ onScoreChange, testId }) => {
  const { t } = useTranslation('training');
  
  const buttonText = testId === 'driver-practice' 
    ? `${t('level1.scoring.driver.driver')}: 1pt` 
    : `${t('level1.scoring.driver.corridor')}: 1pt`;
  
  return (
    <div className="grid grid-cols-1 gap-2">
      <Button 
        className="h-14 bg-yellow-500 hover:bg-yellow-600 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(1)}
      >
        {buttonText}
      </Button>
      <Button 
        className="h-14 bg-red-500 hover:bg-red-600 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(0)}
      >
        {t('level1.scoring.driver.missed')}: 0pt
      </Button>
    </div>
  );
};

export default DriverScoreButtons;
